import { render, staticRenderFns } from "./WarehouseViewWarehouseConfigured.vue?vue&type=template&id=0d8f86f0"
import script from "./WarehouseViewWarehouseConfigured.vue?vue&type=script&lang=js"
export * from "./WarehouseViewWarehouseConfigured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports